import { createContainer } from '@dbk-legacy/muster/react';

import AssetAccordion from './asset-accordion';

export default createContainer({
  $fragments: {
    state: {
      expandedItem: true,
      setExpandedItem: { $set: 'expandedItem' },
      expandedItemOffset: true,
      setExpandedItemOffset: { $set: 'expandedItemOffset' },
    },
    uiStatic: {
      detailsGroups: true,
    },
  },
}, ({ state, uiStatic }) => {
  return {
    state,
    detailsGroups: uiStatic.detailsGroups,
  }
})(AssetAccordion);
